import { jsx as _jsx } from "react/jsx-runtime";
const Loader = ({ type = 'text-primary', size = false }) => {
    return (_jsx("div", Object.assign({ className: `spinner-border ${size && 'spinner-border-sm'} ${type}`, role: "status" }, { children: _jsx("span", Object.assign({ className: "visually-hidden" }, { children: "Loading..." })) })));
};
export default Loader;
